import React from 'react'
import { Box, Heading, Grid, GridItem } from '@chakra-ui/react'

const Reward = ({ item, fontFamily, dictionary, skin, isBusiness }) => {
  const renderOpeningHours = () => {
    if (
      Object.keys(item.opening_hours).length === 0 ||
      item.opening_hours === undefined
    ) {
      return null
    } else if (item.opening_hours?.open === true) {
      return dictionary.CARDS.open
    } else if (item.opening_hours?.open === false) {
      return dictionary.CARDS.close
    } else {
      return null
    }
  }

  const renderBusinessSchedule = () => {
    if (
      item?.business_type === 'physicalVenue' ||
      item.business_type?.type === 'physicalVenue'
    ) {
      return (
        <Heading
          m='0'
          color={
            item.opening_hours
              ? item.opening_hours.open === true
                ? 'brand.success'
                : 'brand.error'
              : null
          }
          fontSize={['sm', 'sm', 'sm', 'sm']}
          fontFamily={fontFamily}
          fontWeight='500'
        >
          {renderOpeningHours()}
        </Heading>
      )
    }
  }
  return (
    <Grid
      w='100%'
      templateColumns='repeat(12, 2fr)'
      pt={skin === 'COPPEL' ? '7px' : '2rem'}
      pb='.5rem'
      borderBottom='1px solid #00000061'
    >
      <GridItem
        colSpan={[9, 9, 9, 9]}
        display='flex'
        alignItems='center'
        justifyContent='flex-start'
      >
        <Heading
          color='brand.secondaryDark'
          m='0'
          fontSize={['md', 'md', 'sm', 'sm']}
          fontFamily={fontFamily}
          fontWeight='500'
        >
          {!isBusiness ? dictionary.CARDS[item.rules.quick_type] : ''}
        </Heading>
      </GridItem>
      <GridItem
        colSpan={[3, 3, 3, 3]}
        display='flex'
        alignItems='center'
        justifyContent='center'
      >
        {!isBusiness && (
          <Box
            w='100%'
            display='flex'
            alignItems='center'
            justifyContent='flex-end'
            flexDirection='row'
          >
            {item.business_type ? renderBusinessSchedule() : null}
          </Box>
        )}
      </GridItem>
    </Grid>
  )
}

export default Reward
